import { Image as DatoImage } from "react-datocms";
import classNames from "classnames";
import { ImageType } from "@/types";
import { Container } from "@material-ui/core";
import { HorizontalRule } from "@narrative-software/narrative-web-ui";
import Section from "./Section";

type IconFeatures3upProps = {
  title: string;
  items: { title: string; icon: ImageType; description: string }[];
};

const IconFeatures3up = ({ title, items }: IconFeatures3upProps) => {
  return (
    <Section className={classNames("bg-white")}>
      <Container>
        <HorizontalRule bottomMargin />
        <h2 className="text-h2 font-semibold leading-compact text-center mb-14 lg:mb-16">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-6 gap-10">
          {items.map((item) => (
            <div key={item.title} className="text-center">
              <div className="h-auto md:h-[75px]">
                <DatoImage data={item.icon.responsiveImage} className="pointer-events-none mx-auto" priority />
              </div>
              <h3 className="text-h3 font-semibold leading-compact text-center mt-6 md:mt-4 mb-4">{item.title}</h3>
              <p className="text-16">{item.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export { IconFeatures3up };
